module.exports = __webpack_public_path__ + "static/img/12.d6a92fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/4/zh/12.png
// module id = cEVG
// module chunks = 0